const amountDetails = {
    INTERFACE: 42,
    MOBILE: 40,
    DESIGN: 44
}

export default amountDetails



// WEBPACK FOOTER //
// ./src/edit-lib/amountDetails.js